import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const BookConsultation = () => {
  // Cal.com embed URL - replace with actual calendar link
  const calendarUrl = "https://cal.com/velmont-society/consultation";

  return (
    <div data-testid="book-consultation-page" className="min-h-screen pt-24 md:pt-32">
      {/* Page Header */}
      <section className="px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <p className="text-gold text-xs uppercase tracking-[0.4em] mb-5 font-manrope font-medium">
              Private Consultation
            </p>
            <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-[#F5F5F0] mb-8 leading-[1.1]">
              Let's Talk <span className="italic">Possibilities</span>
            </h1>
            <p className="text-[#A1A1AA] text-base md:text-lg font-manrope font-light leading-relaxed">
              Book a private 30-minute consultation with our team. No obligation, 
              no pressure — just a conversation about what you're looking for 
              and how we might help.
            </p>
          </div>
        </div>
      </section>

      {/* Calendar Section */}
      <section className="px-6 md:px-12 lg:px-24 pb-28 md:pb-36">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
            {/* Calendar Embed Placeholder */}
            <div className="lg:col-span-2">
              <div className="bg-obsidian-paper border border-white/5 p-8 md:p-12">
                <div className="text-center py-16">
                  <Calendar className="mx-auto text-gold/50 mb-6" size={48} strokeWidth={1} />
                  <h3 className="font-playfair text-2xl text-[#F5F5F0] mb-4">
                    Schedule Your Call
                  </h3>
                  <p className="text-[#A1A1AA] text-sm mb-8 max-w-md mx-auto">
                    Select a time that works for you. All consultations are conducted 
                    via video call or phone, whichever you prefer.
                  </p>
                  <a
                    href={calendarUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="calendar-link"
                    className="inline-flex items-center gap-3 bg-gold text-black px-10 py-4 text-xs uppercase tracking-[0.2em] font-bold hover:bg-gold-light transition-all duration-500 luxury-btn"
                  >
                    Open Calendar
                    <ArrowRight size={16} />
                  </a>
                  <p className="text-[#3F3F46] text-xs mt-6">
                    Powered by Cal.com • Your time zone will be detected automatically
                  </p>
                </div>
              </div>
            </div>

            {/* Sidebar Info */}
            <div className="space-y-8">
              <div className="bg-obsidian-paper border border-white/5 p-8">
                <h4 className="text-gold text-xs uppercase tracking-[0.2em] mb-4 font-manrope font-medium">
                  What to Expect
                </h4>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 bg-gold/60 mt-2" />
                    <p className="text-[#A1A1AA] text-sm font-manrope font-light">
                      30-minute private call with a senior concierge
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 bg-gold/60 mt-2" />
                    <p className="text-[#A1A1AA] text-sm font-manrope font-light">
                      Discuss your vision, dates, and preferences
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 bg-gold/60 mt-2" />
                    <p className="text-[#A1A1AA] text-sm font-manrope font-light">
                      Receive initial recommendations and possibilities
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 bg-gold/60 mt-2" />
                    <p className="text-[#A1A1AA] text-sm font-manrope font-light">
                      No commitment required
                    </p>
                  </li>
                </ul>
              </div>

              <div className="bg-obsidian-paper border border-white/5 p-8">
                <h4 className="text-gold text-xs uppercase tracking-[0.2em] mb-4 font-manrope font-medium">
                  Before Your Call
                </h4>
                <p className="text-[#A1A1AA] text-sm font-manrope font-light leading-relaxed">
                  Think about your ideal dates, group size, and any specific 
                  experiences you've been curious about. The more we know, 
                  the better we can prepare.
                </p>
              </div>

              <div className="border border-gold/20 p-8">
                <h4 className="text-gold text-xs uppercase tracking-[0.2em] mb-4 font-manrope font-medium">
                  Prefer Email?
                </h4>
                <p className="text-[#A1A1AA] text-sm font-manrope font-light mb-6">
                  If you'd rather share details in writing first, use our 
                  contact form instead.
                </p>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-[0.2em] font-medium hover:text-gold-light transition-colors"
                >
                  Contact Form
                  <ArrowRight size={12} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookConsultation;
